import { IEntityChildren } from '../types';
import { EntityService } from '.';
import { ICustomReportingEntityType } from '../types/CustomReportingEntityType';
import axios from 'axios';

export class ReportingEntityTypeService extends EntityService<ICustomReportingEntityType> {
    protected childrenEntities = ['Contributors($expand=ContributorUser)', 'Attributes($expand=AttributeType)'];

    constructor() {
        super(`/ReportingEntityTypes`);
    }

    public readAllForLookup(): Promise<ICustomReportingEntityType[]> {
        return this.readAll(
            `?$select=ID,Title,ReportTypeID`
            + `&$orderby=Title`
        );
    }

    public readAllForList(): Promise<ICustomReportingEntityType[]> {
        return this.readAll(
            `?$filter=ID gt 0`
            + `&$orderby=Title`
            + `&$expand=ReportType`
        );
    }

    public readAllForNavigation(): Promise<ICustomReportingEntityType[]> {
        return this.readAll(`?$filter=ID gt 0&$select=ID,Title,ReportTypeID`);
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const reportingEntityTypeUrl = `${this.entityUrl}(${id})`;
        const entities = (await this.axiosGet(`${reportingEntityTypeUrl}/ReportingEntities?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Reporting entities', CanBeAdopted: false, ChildIDs: (await entities).map((w: {ID: any}) => w.ID) }
        ];
    }
}